// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import EndpointsTestingComponent from './endpointsTestingComponent'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
        function PaymentTerminalUnbindingTestingEndpoints(
        props
        )
        {
            const [{response: paymentTerminalUnbinding, isLoading: paymentTerminalUnbindingLoading, error: paymentTerminalUnbindingError}, paymentTerminalUnbindingFetch, paymentTerminalUnbindingClear] = useAxios()
            const paymentTerminalUnbindingPost = 
                (paymentTerminalUnbindingParams, responseCallback, errorCallback, cancelCallback) => {
                    paymentTerminalUnbindingFetch({
                        url: `/Proxy/PaymentTerminalUnbinding`,
                        data: paymentTerminalUnbindingParams,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function mainRender() {
                return (
                    <div className='container-lg'>
                        <div className='display-4'>PaymentTerminalUnbindingTestingEndpoints</div>
                    </div>
                )
            }
            return (
                <>
                    {mainRender()}
                    {paymentTerminalUnbindingLoading && <Loading isSaving/>}
                    {paymentTerminalUnbindingError && <ErrorMessage error={paymentTerminalUnbindingError} fetchForInit={paymentTerminalUnbindingClear}/>}
                    {paymentTerminalUnbinding && <Success/>}
                    <EndpointsTestingComponent
                        paymentTerminalUnbinding={paymentTerminalUnbinding}
                        onPaymentTerminalUnbindingPost={paymentTerminalUnbindingPost}
                        onPaymentTerminalUnbindingClear={paymentTerminalUnbindingClear}
                        {...props}
                    />
                </>
            )
        }
